const breadCrumb =
  "Diário Digital - Inclusão de Opção para o Componente da Turma";

const routes = [
  {
    path: "/inclusao-de-opcao-para-o-componente-da-turma",
    name: "inclusao-de-opcao-para-o-componente-da-turma",
    meta: {
      allowedPermissions: [
        "consulta_opcoes_componente_por_turma",
        "salvar_opcao_componente_area_disciplina",
        "visualizar_detalhes_area_disciplina",
      ],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/InclusaoDeOpcaoParaOComponenteDaTurma/InclusaoDeOpcaoParaOComponenteDaTurmaHome.vue"
      ),
  },
];

export default routes;
